import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export const useMutationSubscriptionChangeUnschedule = ({
  api,
  subscriptionId,
  onError,
  onSuccess,
}: {
  api: ApiType;
  subscriptionId: number;
  onSuccess?: UseMutationOptions<unknown, unknown, void>["onSuccess"];
  onError?: UseMutationOptions<unknown, unknown, void>["onError"];
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      await api.profileApi.subscriptionChangeUnschedule({
        subscriptionId,
      }),
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.getCurrentMembershipSubscription(),
      });
      onSuccess?.(data, variables, context);
    },
    onError,
  });
};
